import * as React from 'react';
import { useSession } from '@/state/session';
import { can, type Resource, type Action } from '@/lib/rbac';

interface PermissionGateProps {
  resource: Resource;
  action: Action;
  children: React.ReactNode;
  fallback?: React.ReactNode;
  disable?: boolean;
}

export function PermissionGate({
  resource,
  action,
  children,
  fallback = null,
  disable = false,
}: PermissionGateProps) {
  const { user } = useSession();

  const hasPermission = !!user && can(user.role, resource, action);

  if (!hasPermission) {
    if (disable && React.isValidElement(children)) {
      // tenta desabilitar o próprio componente
      return React.cloneElement(children, {
        disabled: true,
        className: `${(children.props as any)?.className ?? ''} opacity-50 cursor-not-allowed`,
      });
    }
    return <>{fallback}</>;
  }

  return <>{children}</>;
}
